import { Typography } from 'shared/ui'
import styles from './styles.module.scss'

export const AutomationLogsEmptyState = () => {
  return (
    <div className={styles.container}>
      <Typography
        ariaLabel='automationLogsEmptyState'
        variant='body-rg-medium'
        color='var(--content-primary-primary)'
      >
        No automation logs yet
      </Typography>
    </div>
  )
}
